function leadFormService(
    localStorageService,
    sessionStorageService,
    userDataService,
    alsService,
    vdpStatTrackingService,
    $cookies,
    historyStateService,
    postLeadSurveyService,
    pageStateService,
    modalService
) {
    const SRP_URL = 'srp-url';
    const INVENTORY_EXTENSION_PAGE_FROM_ID = 2393;

    const service = {
        submitLead,
        transformDrvListing,
        errorCallback,
        setDefaultToChatTab,
        getDefaultToChatTab,
        emailTabClickStateUpdate,
        chatTabClickStateUpdate,
        setModalActions,
        modalCloseStateUpdate,
        trackLeadWithDtm,
        getSearchAlertsConfig(){
            const userData = userDataService.get();

            return {
                name: createSearchName(userData),
                url: getSrpUrl(userData)
            };
        },
        getCarsVisitorCookie,
    };

    let defaultToChatTab;
    let chatAlsSubmitCheck;

    return service;

    function createSearchName(userData) {
        var str = '';
        if (userData.stockType) {
            str += userData.stockType;
            str += ' ';
        }
        if (userData.make) {
            str += userData.make;
            str += ' ';
        }
        if (userData.model) {
            str += userData.model;
            str += '';
        }

        str = str && str[0].toUpperCase() + str.slice(1);

        if (str.length === 0) {
            str = 'New and Used Vehicles';
        }
        str.trim();
        //check to confirm userData exists. Prevents occasional timing issue with SauceLabs' emulators for automated testing
        if (userData.make && _isPluralize(userData.make)) {
                str += 's for Sale';
        }
        return str;
    }

    function _isPluralize(makeName) {
        if (makeName.indexOf('Mercedes') !== -1) {
            return false;
        } else if (makeName.indexOf('Lexus') !== -1) {
            return false;
        }
        return true;
    }

    function getSrpUrl(userData) {
        return historyStateService.referrer().indexOf('searchresults.action') > 0 && sessionStorageService.getItem(SRP_URL) !== null ? "https://cars.com" + sessionStorageService.getItem(SRP_URL) :
            'https://www.cars.com/for-sale/searchresults.action/?zc=' + userData.zip + '&rd=' + userData.radius + '&mkId=' + userData.makeId + '&mdId=' + userData.modelId + '&yrId=' + userData.yearId;
    }

    function submitLead(data, listing, hasEmployees, chatSubmit = false) {
        userDataService.set({map: {intent: 'y'}});
        const isSalesPersonConnect = hasEmployees && !!data.drEmployeeIndex;

        let dtmPageName;

        let leadEventId = data.leadId;

        if (!chatSubmit) {
            localStorageService.setItem('Cars.emailFormData', JSON.stringify(data));
            trackLeadWithDtm(leadEventId, listing, data, hasEmployees);
            trackLeadWithAls(leadEventId, listing, hasEmployees);
            vdpStatTrackingService.trackLead(listing.listingId, data.email);
            postLeadSurveyService.openSurveyModal(data.shadowSettings, listing.bodystyleName, false, dtmPageName);
        } else if (!chatAlsSubmitCheck) {
            fireAlsImpression(listing);
        }
    }

    function errorCallback(errors) {
        /* istanbul ignore next */
        console.log(errors);
    }

    function setModalActions(options) {
        const modal = modalService.get('lead-form');
        if (typeof options.beforeClose == 'function') {
            modal.beforeClose(options.beforeClose);
        }
    }

    function emailTabClickStateUpdate() {
        const modal = modalService.get('lead-form');
        if (modal.isOpen()) {
            if (pageStateService.get('page.pageInfo.pageName')[1] !== "leads/emailLeadForm" && pageStateService.get('page.pageInfo.channel')[1] !== "leads"){
                pageStateService.push('page.pageInfo.pageName', 'leads/emailLeadForm', false);
                pageStateService.push('page.pageInfo.channel', 'leads', false);
            }
        }
    }

    function chatTabClickStateUpdate() {
        const modal = modalService.get('lead-form');
        if (modal.isOpen()) {
            if (pageStateService.get('page.pageInfo.pageName')[1] === "leads/emailLeadForm" && pageStateService.get('page.pageInfo.channel')[1] === "leads"){
                pageStateService.pop('page.pageInfo.pageName', false);
                pageStateService.pop('page.pageInfo.channel', false);
            }
        }
    }

    function modalCloseStateUpdate() {
        setModalActions({
            beforeClose: () => {
                if (pageStateService.get('page.pageInfo.pageName')[1] === "leads/emailLeadForm" && pageStateService.get('page.pageInfo.channel')[1] === "leads"){
                    pageStateService.pop('page.pageInfo.pageName', false);
                    pageStateService.pop('page.pageInfo.channel', false);
                }
            }
        });
    }

    function trackLeadWithDtm(leadEventId, listing, data, hasEmployees){
        let isShippable = listing.ixtQuery !== null && listing.ixtQuery !== undefined;
        let outsideSearchRadius = listing.ixtQuery === 'isShippableOutsideSearchRadius';
        const modal = modalService.get('lead-form');

        const lead = {
            category: "email",
            isCpoVehicle: listing.isCpoVehicle,
            customerId: listing.customerId,
            leadEventId,
            listingId: listing.listingId,
            location: "vdp",
            name: "submit-email-lead",
            stockType: listing.stockTypeCode,
            make: listing.makeName,
            model: listing.modelName,
            year: listing.modelYear,
            bodystyle: listing.bodystyleName,
            price: listing.price,
            dealer: listing.dealerName,
            inventoryExtension: isShippable,
            inventoryExtensionMarket: outsideSearchRadius,
            dealerMetric: listing.dealerMRevenue ? listing.dealerMRevenue : 0,
            vin: listing.vin
        };

        /* istanbul ignore next */
        if (hasEmployees) {
            /* istanbul ignore next */
           if (data.drEmployeeIndex) {
               lead.employeePrefrence = 'employee-' + data.drEmployeeIndex;
           } else {
               lead.employeePreference = 'no-employee-preference';
           }
        }

        if (modal.isOpen()) {
            pageStateService.pop("page.pageInfo.pageName", false);
            pageStateService.pop("page.pageInfo.channel", false);
        }
        pageStateService.push('page.lead', lead, false);
        pageStateService.push("page.pageInfo.pageName", "leads/emailLeadThanks_VDP", false);
        pageStateService.push("page.pageInfo.channel", "leads", false);
        pageStateService.push('event', {eventName: "lead", eventDetail: "email"}, true);
    }

    function transformDrvListing(drvListing) {
        /* istanbul ignore next */
        return {
            listingId: drvListing.vehicle.id,
            price: drvListing.vehicle.price,
            sellerId: drvListing.vehicle.seller.id,
            privatePartyListing: drvListing.vehicle.privatePartyListing,
            isCpoVehicle: drvListing.vehicle.isCertifiedPreOwned,
            stockTypeCode: drvListing.vehicle.newCarStockType ? "New" : "Used",
            makeName: drvListing.vehicle.make,
            modelName: drvListing.vehicle.model,
            modelYear: drvListing.vehicle.year,
            hasEnhancedSpecialOffers: drvListing.vehicle.hasEnhancedSpecialOffers
        };
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////

    function fireAlsImpression(listing) {
        chatAlsSubmitCheck = true;
        let date = new Date();
        const impressionLog = {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            listingId: listing.listingId,
            modelYearId: listing.modelYearId,
            makeId: listing.makeId,
            modelId: listing.modelId,
            trimId: listing.trimId,
            stockTypeCode: listing.stockTypeCode,
            sellerId: listing.sellerId,
            primaryFeedSourceId: listing.primaryFeedSourceId,
            localOfferId: listing.localOfferId,
            affiliateAgentId: listing.affiliateAgentId,
            pageToId: listing.stockTypeCode === 'New' ? 2409 : 2410
        };
        alsService.impression(impressionLog);
    }

    function trackLeadWithAls(leadEventId, listing, hasEmployees) {
        let {listingId, sellerId, stockTypeCode} = listing;
        let pageFromId = listing.hasEnhancedSpecialOffers
            ? 2289
            : 2104;

        if (listing.ixtQuery) {
            pageFromId = INVENTORY_EXTENSION_PAGE_FROM_ID;
        }

        let leadTypeId;
        if (hasEmployees) {
            leadTypeId = stockTypeCode === 'New'
                ? 88
                : 89;
        } else {
            leadTypeId = stockTypeCode === 'New'
                ? 15
                : 12;
        }

        const alsParams = {
            listingId,
            sellerId,
            leadEventId,
            leadTypeId,
            pageFromId
        };

        alsService.lead(alsParams);
    }

    function setDefaultToChatTab(status) {
        defaultToChatTab = status;
    }

    function getDefaultToChatTab() {
        return defaultToChatTab;
    }

    function getCarsVisitorCookie() {
        return JSON.parse($cookies.get('CarsVisitor')) || {};
    }
}

leadFormService.$inject = [
    'localStorageService',
    'sessionStorageService',
    'userDataService',
    'alsService',
    'vdpStatTrackingService',
    '$cookies',
    'historyStateService',
    'postLeadSurveyService',
    'pageStateService',
    'modalService'
];

export default leadFormService;
